import React from "react";
import "./Frame432.css";

function Frame432(props) {
  const { line36, className } = props;

  return (
    <div className={`frame-43-2 ${className || ""}`}>
      <div className="frame-42-2">
        <div className="group-138-2">
          <div className="how-to-reschedule-cancel poppins-normal-tundora-16px">How to reschedule/ cancel?</div>
        </div>
        <img className="vector-6" src="/img/vector-4@2x.png" />
      </div>
      <img className="line-36-1" src={line36} />
    </div>
  );
}

export default Frame432;
